import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import {currency} from '../../../../../util';
import {ICheckoutStep} from '../../../../i';

declare var modalOpen: any;

interface IShippingEstimateProps {
    showEstBox: boolean;
    EstPostalCode: string;
    freeShipping: boolean;
}

const ShippingEstimate = observer(({showEstBox, EstPostalCode, freeShipping}: IShippingEstimateProps) => {
    return (
        <>
            {!showEstBox && store.checkout.cart.pricing.isEstShipping && (
                <div
                    className="cs-flex"
                    style={{fontSize: 12}}
                >
                    {EstPostalCode === '' && (
                        <div>
                            Ship to:{' '}
                            {store.checkout.cart.pricing.isEstShipping && store.checkout.cstep < ICheckoutStep.shipping && (
                                <span
                                    className="link pointer"
                                    style={{paddingLeft: 4, fontSize: 13}}
                                    tabIndex={0}
                                    onClick={() => modalOpen('modal-shipping-est-postal')}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            modalOpen('modal-shipping-est-postal');
                                        }
                                    }}
                                >
                                    ({EstPostalCode === '' ? 'change' : `${EstPostalCode} (change)`})
                                </span>
                            )}
                        </div>
                    )}
                    {EstPostalCode !== '' && (
                        <div>
                            Ship to: {EstPostalCode}
                            {store.checkout.cstep < ICheckoutStep.shipping && (
                                <span
                                    className="link pointer"
                                    style={{fontSize: 13, paddingLeft: 4}}
                                    tabIndex={0}
                                    onClick={() => modalOpen('modal-shipping-est-postal')}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            modalOpen('modal-shipping-est-postal');
                                        }
                                    }}
                                >
                                    change
                                </span>
                            )}
                        </div>
                    )}
                    <div></div>
                </div>
            )}
            {!showEstBox && store.checkout.cart.pricing.isEstShipping && (
                <div
                    className="cs-flex"
                    style={{paddingTop: 0, minHeight: '24px'}}
                >
                    <div>Estimated Shipping</div>
                    <div aria-label="Estimated Shipping">
                        {!store.uiCheckout.isLoadingEstimated && (
                            <div>
                                {(freeShipping || store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production <= 0) && 'FREE'}
                                {!freeShipping && store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production > 0 && currency(store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production)}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {!showEstBox && store.checkout.cart.pricing.isEstShipping && (
                <div
                    className="cs-flex"
                    style={{paddingTop: 0, minHeight: '24px'}}
                >
                    <div>Estimated Tax</div>
                    <div
                        aria-label="Estimated Tax"
                        role="region"
                        style={{minWidth: '50px', textAlign: 'right'}}
                    >
                        {!store.uiCheckout.isLoadingEstimated && currency(store.checkout.cart.pricing.tax)}
                    </div>
                </div>
            )}
        </>
    );
});

interface IEstimateLinkProps {
    showEstBox: boolean;
}

export const EstimateLink = observer(({showEstBox}: IEstimateLinkProps) => {
    return (
        <>
            {showEstBox && (
                <div className="cs-flex">
                    <div>
                        {store.checkout.cart.pricing.isEstShipping && store.checkout.cstep < ICheckoutStep.shipping && (
                            <span
                                className="link pointer underline"
                                style={{fontSize: 14}}
                                tabIndex={0}
                                onClick={() => modalOpen('modal-shipping-est-postal')}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        modalOpen('modal-shipping-est-postal');
                                    }
                                }}
                            >
                                Estimate Shipping &amp; Tax
                            </span>
                        )}
                    </div>
                    <div
                        aria-label="Estimated Tax"
                        role="region"
                    >
                        {!store.uiCheckout.isLoadingEstimated && store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production > 0 && currency(store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production)}
                    </div>
                </div>
            )}
        </>
    );
});

export default ShippingEstimate;
